import { render, staticRenderFns } from "./notifyAlert.vue?vue&type=template&id=4999b0a5"
import script from "./notifyAlert.vue?vue&type=script&lang=js"
export * from "./notifyAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4999b0a5')) {
      api.createRecord('4999b0a5', component.options)
    } else {
      api.reload('4999b0a5', component.options)
    }
    module.hot.accept("./notifyAlert.vue?vue&type=template&id=4999b0a5", function () {
      api.rerender('4999b0a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/alert/notifyAlert.vue"
export default component.exports